// All actions performed by the user must be specified in a constant, which is
// to be committed by an action, and such commit handled by a mutation
// Read more: https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types

export const IMG__UPDATE_TRANSFORMATION = 'IMG__UPDATE_TRANSFORMATION'
export const IMG__TOGGLE_THRESHOLD = 'IMG__TOGGLE_THRESHOLD'
export const IMG__UPDATE_THRESHOLD_VALUE = 'IMG__UPDATE_THRESHOLD_VALUE'

export const SPLASH_SCREEN__DISABLE = 'SPLASH_SCREEN__DISABLE'

export const MISSION__CREATE_INIT = 'MISSION__CREATE_INIT'
export const MISSION__CREATE_SUCCESS = 'MISSION__CREATE_SUCCESS'
export const MISSION__CREATE_FAILURE = 'MISSION__CREATE_FAILURE'

export const MISSION__SET_ACCURACY = 'MISSION__SET_ACCURACY'

export const COMMENT__FETCH_INIT = 'COMMENT__FETCH_INIT'
export const COMMENT__FETCH_SUCCESS = 'COMMENT__FETCH_SUCCESS'
export const COMMENT__FETCH_FAILURE = 'COMMENT__FETCH_FAILURE'

export const CANDIDATE__GET_INIT = 'CANDIDATE__GET_INIT'
export const CANDIDATE__GET_SUCCESS = 'CANDIDATE__GET_SUCCESS'
export const CANDIDATE__GET_FAILURE = 'CANDIDATE__GET_FAILURE'

export const CANDIDATE__SET = 'CANDIDATE__SET'
